import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { seguridadDAModulo } from "src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule";
import { ClaveValorModel } from '../../model/claveValorModel';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Caracteristica } from '../../model/caracteristicaModel';
import { EmployeModel } from '../../model/employeModel';
import { CaracteristicaService } from '../../services/caracteristica.service';
import { UbitsService } from '../../services/ubits.service';

@Component({
  selector: 'app-crear-usuario-ubits',
  templateUrl: './crear-usuario-ubits.component.html',
  styleUrls: ['./crear-usuario-ubits.component.css']
})
export class CrearUsuarioUbitsComponent implements OnInit {

  mostrarFormulario: boolean = false;
  chkCmbArea: boolean = false;
  chkCmbLocalidad: boolean = false;
  chkCmbEmpleado: boolean = false;
  resposiveFull: string;
  seguridadDAModulo: any = {};

  formulario: FormGroup;

  cmbOpcionesArea: ClaveValorModel[] = [];
  cmbOpcionesLocalidad: ClaveValorModel[] = [];
  cmbOpcionesEmpleado: ClaveValorModel[] = [];
  loading: boolean = false;

  listEmpleados;
  empleadoSelected;

  constructor(private fb: FormBuilder, private _util: UtilsService,
    private _caracteristica: CaracteristicaService,
    private _ubits: UbitsService) { }

  ngOnInit() {
    this.seguridadDAModulo = seguridadDAModulo;
    this.resposiveFull = this.seguridadDAModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      area: [''],
      localidad: [''],
      empleado: [''],
    });

    this.getAllDepartamento();
    this.getAllLocalidad();
  }

  changeCmbArea() {
    this.chkCmbArea = !this.chkCmbArea;
    this.getAllEmpleado();
  }

  changeCmbLocalidad() {
    this.chkCmbLocalidad = !this.chkCmbLocalidad;
    this.getAllEmpleado();
  }

  changeCmbEmpleado() {
    this.chkCmbEmpleado = !this.chkCmbEmpleado;
  }

  crearUsuariosUbits() {
    if (this.chkCmbArea != true && (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Area");
    } else if (this.chkCmbLocalidad != true && (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Localidad");
    } else if (this.chkCmbEmpleado != true && (this.formulario.get('empleado').value == undefined || this.formulario.get('empleado').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todos Empleado");
    } else {
      if(!this.chkCmbEmpleado) return this.crearUsuarioDAUbitsIndividual(); // creación inddivual
      if(this.chkCmbArea && this.chkCmbLocalidad && this.chkCmbEmpleado) return this.crearUsuarioDAUbitsLote(); //creacion lote

      this._util.confirmarSincronoPromesaNormal(
        {
          title: 'Esta seguro que desea crear usuarios en Ubits?',
          text: '',
          action: 'Enviar',
          funcion: this._caracteristica.sincroDAUbitsCreateLoteArea((this.chkCmbArea ? 'ALL' : this.formulario.get('area').value),
            (this.chkCmbLocalidad ? 'ALL' : this.formulario.get('localidad').value),
            (this.chkCmbEmpleado ? 'ALL' : this.formulario.get('empleado').value)),
          loading: true,
          context: this,
        }
      ).then((res: any) => {
        this.formulario.reset();
      }).catch((err) => {
        console.log('Error ' + err);
      });
    }
  }

  crearUsuarioDAUbitsIndividual() {
    const cedula =  this.formulario.get('empleado').value;
    this.empleadoSelected = this.listEmpleados.find(e=> e.cedula == cedula);
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea crear el usuario?',
        text: 'CEDULA ' + cedula,
        action: 'Enviar',
        funcion: this._caracteristica.sincroDAUbitsCreateIndividual(this.empleadoSelected),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.empleadoSelected = null;
      this.formulario.reset();
    }).catch((err) => {
      console.log('Error ' + err);
    });
    
    this.loading = false;
  }

  crearUsuarioDAUbitsLote() {
    const cedula =  this.formulario.get('empleado').value;
    this.empleadoSelected = this.listEmpleados.find(e=> e.cedula == cedula);
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea crear el usuario?',
        text: 'CEDULA ' + cedula,
        action: 'Enviar',
        funcion: this._caracteristica.sincroDAUbitsCreateLote(),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.empleadoSelected = null;
      this.formulario.reset();
    }).catch((err) => {
      console.log('Error ' + err);
    });
    
    this.loading = false;
  }



  getAllDepartamento() {
    this.cmbOpcionesArea = [];
    this._caracteristica.getAllDepartamento().subscribe((res: Caracteristica[]) => {
      res.forEach((item) => {
        this.cmbOpcionesArea.push({ clave: item.codigo, valor: item.descripcion + ' (' + item.codigo + ')' });
      });
    }, (err) => {
      console.log(err);
      this.cmbOpcionesArea = [];
      if (err.error.key == '500') {
        this._util.mensajeErroToast(err.error.message);
      } else {
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  getAllLocalidad() {
    this.cmbOpcionesLocalidad = [];
    this._caracteristica.getAllLocalidad().subscribe((res: Caracteristica[]) => {
      res.forEach((item) => {
        this.cmbOpcionesLocalidad.push({ clave: item.codigo, valor: item.descripcion + ' (' + item.codigo + ')' });
      });
    }, (err) => {
      console.log(err);
      this.cmbOpcionesLocalidad = [];
      if (err.error.key == '500') {
        this._util.mensajeErroToast(err.error.message);
      } else {
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  getAllEmpleado() {
    debugger;
    this.cmbOpcionesEmpleado = [];
    this.listEmpleados       = [];

    if (this.chkCmbArea == true && this.chkCmbLocalidad == true) {
      this._caracteristica.getAllEmpleado().subscribe((res: EmployeModel[]) => {
        this.listEmpleados = res;
        res.forEach((item) => {
          this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
        });
      }, (err) => {
        console.log(err);
        this.cmbOpcionesEmpleado = [];
        if (err.error.key == '500') {
          this._util.mensajeErroToast(err.error.message);
        } else {
          this._util.mensajeErroToast('No se encontro información.');
        }
      });
    } else if (this.chkCmbArea == true && this.chkCmbLocalidad == false) {

      if (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Localidad.');
      } else {
        this._caracteristica.findEmpleadoByLocalidad(this.formulario.get('localidad').value).subscribe((res: EmployeModel[]) => {
          this.listEmpleados = res;
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    } else if (this.chkCmbArea == false && this.chkCmbLocalidad == true) {

      if (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Departamento.');
      } else {
        this._caracteristica.findEmpleadoByDepartamento(this.formulario.get('area').value).subscribe((res: EmployeModel[]) => {
          this.listEmpleados = res;
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    } else if (this.chkCmbArea == false && this.chkCmbLocalidad == false) {

      if (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Departamento.');
      } else if (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Localidad.');
      } else {
        this._caracteristica.findEmpleadoByDepLoc(this.formulario.get('area').value, this.formulario.get('localidad').value).subscribe((res: EmployeModel[]) => {
          this.listEmpleados = res;
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    }
  }

}
